import CountUp from "react-countup";
import { useInView } from "framer-motion";
import { useRef } from "react";

const STATS = [
    { v: 30, suffix: "+", label: "Years at sea", note: "Compounded operational legacy" },
    { v: 38, suffix: "", label: "Vessels managed", note: "Owned · operated · chartered" },
    { v: 12.4, suffix: " Mt", decimals: 1, label: "Cargo moved / yr", note: "Across all segments" },
    { v: 60, suffix: "+", label: "Active trade lanes", note: "Spanning four continents" },
    { v: 99.4, suffix: "%", decimals: 1, label: "On-time delivery", note: "Trailing 12-month average" },
    { v: 240, suffix: "+", label: "Crew & shore staff", note: "Singapore + offshore offices" },
];

export default function StatsCounter() {
    const ref = useRef(null);
    const inView = useInView(ref, { once: true, margin: "-100px" });

    return (
        <section data-testid="stats-counter" ref={ref} className="relative py-24 md:py-32 bg-[#0B1324] border-y border-white/5 overflow-hidden">
            <div className="absolute inset-0 wms-grid-bg opacity-40 pointer-events-none" />
            <div className="wms-container relative">
                <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
                    <div className="max-w-2xl">
                        <span className="wms-overline">Performance — 06</span>
                        <h2 className="mt-5 font-display font-light text-4xl md:text-5xl leading-tight tracking-tight">
                            Numbers that move with the tide.
                        </h2>
                    </div>
                    <p className="md:max-w-sm text-white/55 text-sm md:text-base">
                        Our dashboards reconcile every voyage, every laycan and every demurrage line — so you never lose visibility.
                    </p>
                </div>

                <div className="grid grid-cols-2 md:grid-cols-3 gap-px bg-white/5 border border-white/5">
                    {STATS.map((s, i) => (
                        <div key={s.label} data-testid={`stat-item-${i}`} className="bg-[#0B1324] p-8 md:p-10 hover:bg-[#101a30] transition-colors">
                            <div className="flex items-baseline gap-1 font-display">
                                <span className="text-5xl md:text-6xl text-white tracking-tight">
                                    {inView ? (
                                        <CountUp
                                            end={s.v}
                                            duration={2.4}
                                            decimals={s.decimals || 0}
                                            separator=","
                                        />
                                    ) : 0}
                                </span>
                                <span className="text-2xl md:text-3xl text-[#48CAE4]">{s.suffix}</span>
                            </div>
                            <div className="mt-4 text-[11px] tracking-[0.32em] uppercase text-white/55">{s.label}</div>
                            <div className="mt-2 text-sm text-white/40">{s.note}</div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
